<div class="modal-header modal-pepsico-header">
</div>
<div class="modal-body text-center">
  <div class="container">
    <div class="row">
      <iframe width="100%" height="315" src="https://www.youtube.com/embed/WZJhQ13-CBk?si=0rPMqO2U7elhAge4"
        title="YouTube video player" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      <hr>
      <div class="col-sm-12 text-center">
        <button type="button" class="btn btn-primary perfilbtn-pep btn-modal-canje"
          (click)="ngbActiveModal.close()">Cerrar</button>
      </div>
    </div>
  </div>
</div>
